export const language: any = {
  ESP: {
    featured: "Destacados",
    outstanding: "Destacado",
    searchPlaceholder: "Buscar productos, categorías y más...",
    searchMessage: "Ingresa una palabra para iniciar la búsqueda",
    home: "Inicio",
    category: "Categorías",
    allCategory: "Todas las categorías",
    selling: "Empieza a vender",
    footerAdvertising:
      "Crea una cuenta ahora y comparte tus productos y catálogos",
    newAccount: "Crear cuenta",
    termsAndConditions: "Términos y condiciones",
    contact: "Contacta al comercio",
    loading: "Cargando",
    notFoundProduct: "No hay productos que coincidan con la búsqueda",
    resultFor: "resultados para",
    showing: "Mostrando",
    products: "productos",
    products2: "Productos",
    sortBy: "Ordenar por",
    recent: "Reciente",
    lowestFirst: "Menor precio primero",
    highestFirst: "Mayor precio primero",
    from: "Desde",
    optionSend: "Opciones de envío",
    messageDelivery:
      "Estás viendo precios disponibles para comprar en esta ubicación. Si no es donde te encuentras puedes cambiarla aquí.  ",
    maintainLocation: "Mantener Ubicación",
    changeLocation: "Cambiar Ubicación",
    messageDeliverySelected:
      "Debe seleccionar la ciudad donde será llevado el pedido y el proveedor que lo entregara",
    ok: "De acuerdo",
    sendFree: "Envíos GRATIS",
    allProduct: "Para todos los productos",
    continueCategory: "Continúe viendo más productos de esta categoría",
    more: "Ver más",
    summary: "Resumen de tu compra",
    subtotal: "Subtotal",
    tax: "Impuestos",
    tax2: "impuestos",
    tax3: "Impuesto",
    discount: "Código de descuento",
    totalDiscount: "Total descuento",
    free: "Gratis",
    free2: "GRATIS",
    send: "Envío",
    freeShipping: "Envío gratis",
    freeShippingProductPrefix: "Agrega solo",
    freeShippingProductSuffix: "más para tu envío gratis",
    freeShippingProductFooterStrong: "Envío gratuito automático",
    freeShippingProductFooterMiddle: "aplicado al superar",
    freeShippingProductFooterSuffix: "en el carrito.",
    freeShippingStepOnePrefix: "¡Estás a solo",
    freeShippingStepOneMiddle: "de obtener",
    freeShippingStepOneStrong: "ENVÍO GRATIS",
    freeShippingStepsPrefix:
      "Aún estás a tiempo. Agrega más productos y disfruta de envío GRATIS en compras desde",
    freeShippingReached: "¡Listo! Tu envío gratis se aplicó correctamente!",
    freeShippingBannerStrong: "¡Aprovecha!",
    freeShippingBannerPrefix: "Si tu compra supera los",
    freeShippingBannerSuffix: "el envío va por nuestra cuenta.",
    codeMessage:
      "Los códigos de descuentos y los costos de envío se añaden en los siguientes pasos.",
    errorCode: "No es posible combinar estos códigos de descuento.",
    errorCode2: "Este código de descuento no se encuentra disponible",
    errorCode3: "Este código ya fue agregado",
    errorCode4: "Ha ocurrido un error consultado el cupón",
    errorCode5:
      "Este código de descuento será aplicable en compras mayores a {amount}",
    errorCode6:
      "Este código de descuento solo puede ser aplicado a los productos de ",
    errorCode7: "El total de la compra no puede ser 0",

    errorCode8:
      "Este código de descuento solo puede ser aplicado a los productos de las categorías {categories}",
    errorCode9:
      "La sumatoria de los códigos de descuento no puede ser superior a 90%.",
    error: "Ha ocurrido un error,",
    codeDiscount: "Código de descuento",
    total: "Total",
    messageSubtotalsend: "Puede variar según información de envío",
    agree: "De acuerdo",
    authorization:
      "Autorizo de manera previa, expresa e inequívoca que mis datos personales sean tratados por Epayco.com conforme a las finalidades establecidas en su",
    authorization3: `Autorizo de manera previa, expresa e inequívoca que mis datos
		personales sean tratados por epayco.com `,
    authorization4: "conforme a las finalidades establecidas en su ",
    authorization2: "Política de tratamiento de datos personales",
    messageCityChange: `Tenga en cuenta que al cambiar la dirección 
        seleccionada, los costos de envío serán 
        calculados nuevamente.`,
    location: "Ubicación",
    locationChangeSuccess:
      "Tu ubicación ha sido actualizada exitosamente, puedes realizar el cambio cuando sea necesario.",
    page: "Página",
    of: "de",
    prev: "Anterior",
    next: "Siguiente",
    conditionPage: "El valor no puede ser 0 ni mayor al total de paginas",
    province: "Departamento",
    city: "Ciudad",
    country: "País",
    seletedCity: "Seleccione una ciudad",
    selectedDepartament: "Seleccione un departamento",
    selectedContry: "Seleccione un país",
    selectedProvince: "Seleccione una departamento",
    messageShipping:
      "Esta ubicación nos ayudará a brindarte una mejor experiencia de compra. Si no es la ubicación donde necesitas el pedido, aquí puedes cambiarla.",
    labelInputsShiping: "Estado/departamento",
    save: "Guardar",
    cancel: "Cancelar",
    addProductSuccess: "Producto agregado con éxito a tu carrito de compras",
    ref: "Referencia",
    totalToPay: "Total a pagar",
    viewCart: "Ver carrito",
    cart: "Carrito",
    continueShopping: "Continuar comprando",
    continue: "Continuar",
    placeholderSearch: "Busque productos, categorías y más...",
    summaryPurchase: "Resumen de la compra",
    detailPay: "Detalle del Pago",
    information: "Información",
    relatedProduct: "Productos relacionados",
    urlCopy: "URL copiada",
    shippingProvider: "Transportadora",
    cost: "Costo",
    messageInfoRequered:
      "Lo sentimos, por favor complete la información solicitada.",
    shoppingCart: "Carrito de compras",
    shoppingCartEmpty: "Tu carrito actualmente esta vacío",
    sucessPay: "¡Compra exitosa!",
    messageSucessPay:
      "Hemos enviado un mensaje al correo registrado con el resultado de la compra",
    pendingPay: "Pago pendiente",
    messagePendingPay:
      "Te enviaremos un mensaje al correo electrónico registrado tan pronto se confirme tu pago",
    rejectPay: "Pago Rechazado",
    messageRejectPay:
      "Ha ocurrido un error al realizar el pago, Inténtalo nuevamente",
    unit: "unidad",
    units: "unidades",
    space: "Espacio",
    product: "Producto",
    amount: "Cantidad",
    price: "Precio",
    methodShipping: "Forma de envío",
    receives: "Recibe",
    phone: "Teléfono",
    email: "Correo",
    payment: "Tu pago",
    pay: "Pago",
    paymentNumber: "Número de pago",
    transactionDate: "Fecha de transacción",
    hour: "Hora",
    productSummary: "Resumen de Productos",
    contactEcommerce: "Contacta al Comercio",
    cellPhone: "Número de celular incorrecto",
    printMessage: "Escribe un mensaje aquí",
    tryLater: "Lo sentimos, ha ocurrido un error inesperado. Intenta más tarde",
    hi: "Hola, ¿cuéntanos cómo podemos ayudarte?",
    catalogueInactive: "Este catálogo se encuentra inactivo",
    shoppingDelete: "Carrito ha sido abandonado o eliminando.",
    messageElogisticaError:
      "Acabas de sobrepasar el límite de peso y/o dimensiones del carrito, te recomendamos dividir tu pedido en 2 compras.",
    messageElogisticaError2:
      "Lo sentimos, en este momento no hay disponible un servicio de logística para el destino que seleccionaste. Por favor comuníquese con el comercio vendedor.",
    messageElogisticaError3:
      "El peso y/o dimensiones de uno de los productos esta mal configurado, te recomendamos contactar con el vendedor.",
    messageElogisticaError4:
      "Lo sentimos, ha ocurrido un error inesperado. Por favor comuníquese con el comercio vendedor.",
    categories: "las categorías",
    category2: "la categoría",
    consulting: "consultando",
    phoneInvalid: "Ingrese un teléfono válido",
    saveInfo: "Guardar información",
    messageAuthorization:
      "Al seleccionar esta casilla, autoriza a ePayco para almacenar de forma segura su información de envío para futuras compras.",
    messageAuthorizationAveonline:"Al seleccionar esta casilla, estas autorizando almacenar de forma segura su información de envió para futuras compras",
    back: "Volver",
    menssageChangeInfo: `Al cambiar el departamento y/o ciudad 
		se recalcula el valor de envío de los productos.`,
    inputAddress: "Ingrese una dirección",
    infoContact: "Información de contacto",
    inputEmail: "Ingrese su correo electrónico para iniciar",
    inputSelect: "Selecciona...",
    completedInfo: "Completa información",
    name: "Nombre",
    nameAveonline:"Escribe...",
    lastname: "Apellido",
    inputName: "Ingrese su nombre",
    inputLastname: "Ingrese su apellido",
    inputNumber: "Ingrese su nro. de documento",
    numberDoc: "Nro. de documento",
    address: "Dirección",
    otherAdress: "Otros detalles (opcional)",
    empatyCart: "Tu carrito de compras esta vacio",
    addProduct: "Agregar productos",
    politycData: "Política de tratamiento de datos personales",
    sentMessage: "Envío realizado con eLogística",
    dataCommerce: "Datos del comprador",
    deliveryCommerce: "Entrega coordinada con el comercio",
    sorry: "¡Lo sentimos!",
    notFound: "No se encontró la página",
    searchMessage2: "que estas buscando",
    goHome: "Ir al inicio",
    inactiveCatalogue: "Catálogo no disponible",
    messageInactiveCatalogue1: "Actualmente este catálogo no está",
    messageInactiveCatalogue2:
      "disponible, intente más tarde o contacte al comercio",
    createAccount:
      "Cree una cuenta y empiece a vender y cobrar seguro con ePayco",
    learnMore: "Conocer más de ePayco",
    chooseReference: "Elegir una referencia",
    productsAvailable: "productos disponibles",
    calculateShipping: "Calcular envío",
    selectDeliveryCity: "Seleccionar ciudad de entrega",
    buyNow: "Comprar ahora",
    addToCart: "Agregar al carrito",
    accept: "Aceptar",
    chooseOtherPaymentMethod: "Elegir otro método de pago",
    print: "Imprimir",
    paymentOf: "Pago de",
    FourSevenTwoShipping: "Envío 4-72",
    goToHomePage: "Ir a la página de inicio",
    categories2: "Categorias",
    backShoping: "Volver a Comprar",
    sendTo: "Enviado a",
    infoCart: "Info",
    paymentCart: "Pago",
    addMoreProducts: "Agregar más productos",
    valueNextStep: `*Valor calculado\nen el siguiente paso`,
    payCart: "Pagar",
    noCartError: "No encontramos un carrito",
    epaycoCom: "Epayco.com",
    termsAgreement: "Confirmo que acepto los ",
    termsAgreement2: " de los servicios ofrecidos por ePayco.",
    transactionAmountValidation:
      "El valor de la transacción está fuera de los montos soportados por el comercio",
    productUnavailable: "Producto no disponible",
    transactionError: "Hubo un error al intentar realizar la transacción",
    restrictedUser: "La transacción no puede ser procesada en este momento conforme a nuestras políticas. Para mayor información, por favor contacta al equipo de soporte.",
    documentNit: "Formato inválido. Ej: 900123456-7",
    documentNumber:"Solo números",
    cc: 'Cédula de ciudadanía',
    nit: 'NIT',
    typeDocumentLabel: "Tipo de documento",
    documentNumberLabel: "Número de documento",
    documentTypeRequired: "Tipo de documento es obligatorio",
    documentNumberRequired:"Número de documento es obligatorio",
    marcaBlancaTitle: "Ingresa la información solicitada.",
    marcaBlancaIntroOne:"Con estos datos realizaremos la validación de tu cuenta modelo",
    marcaBlancaIntroTwo: "Agregador ePayco. Si cumple con los requisitos, podrás continuar con",
    marcaBlancaIntroThree: "la compra.",
    marcaBlancaIdLabel: "ID epayco",
    marcaBlancaNumberPlaceholder: "Número documento",
    marcaBlancaEnter: "Validar",
    marcaBlancaClose: "Cerrar",
    marcaBlancaIdRequired: "El ID ePayco es obligatorio y solo admite números",
    marcaBlancaIdInvalid: "ID ePayco inválido",
    marcaBlancaNoAccount: "¿No tienes cuenta ePayco? Puedes ",
    marcaBlancaCreateLink: "crearla ahora",
    marcaBlancaNoAccountSuffix: " y volver para completar tu pedido.",
    marcaBlancaReqTitle: "Aún no puedes completar tu compra",
    marcaBlancaReqIntro:
      "Para comprar tu datáfono, primero debes completar los siguientes requisitos:",
    marcaBlancaReqAggregator: "Tipo de modelo Agregador",
    marcaBlancaReqValidated: "Cuenta validada al 100%",
    marcaBlancaReqDavivienda: "Cuenta con Plan Davivienda",
    marcaBlancaReqDaviviendaDesc:
      "Necesitas una cuenta Davivienda vinculada y predeterminada \npara continuar con la compra.",
    marcaBlancaReqDaviviendaDescAction:
      "Necesitas una cuenta Davivienda vinculada y \npredeterminada para continuar con la compra.",
    marcaBlancaReqAcknowledge: "Entendido",
    marcaBlancaReqIntroNotFound:
      "Necesitas crear una cuenta ePayco antes de comprar tu datáfono.",
    marcaBlancaReqIntroAlreadyBought:
      "No puedes adquirir más datáfonos para tus sucursales.\nIngresa a tu cuenta ePayco para registrar una nueva sucursal\n o validar el estado de una existente.",
    marcaBlancaReqAggregatorDesc: "Tu cuenta ePayco debe ser modelo Agregador",
    marcaBlancaReqValidatedDesc:
      "Finaliza el proceso de validación para activar tu cuenta al 100%.",
    marcaBlancaReqCtaCreate: "Crear cuenta",
    marcaBlancaReqCtaValidate: "Validar cuenta",
    marcaBlancaReqCtaLink: "Vincular cuenta",
    marcaBlancaCartLimitTitle: "No es posible agregar más productos al carrito.",
    marcaBlancaCartLimitMessage:
      "Has alcanzado la cantidad máxima de datáfonos disponibles para esta compra.",
    marcaBlancaCartLimitGoToCart: "Ir al carrito",
    cartValidationTitle: "Tu carrito necesita ajustes",
    cartValidationIntro:
      "No podemos continuar con el pago porque estos ítems cambiaron. Al aceptar volverás al carrito para modificarlos.",
    cartValidationGenericMessage:
      "No podemos continuar con el pago porque tu carrito cambió. Al aceptar volverás al carrito para revisarlo.",
    cartValidationStoreTitle: "La tienda no está disponible",
    cartValidationStoreMessage:
      "En este momento nos encontramos temporalmente fuera de servicio, por favor intenta de nuevo más tarde.",
    cartValidationInactiveProducts: "Productos que ya no están disponibles",
    cartValidationInactiveCategories: "Categorías que ya no están disponibles",
    cartValidationMissingReferences: "Presentaciones que ya no están disponibles",
    cartValidationChangedPrices: "Productos que cambiaron de precio",
    cartValidationPriceBefore: "Antes:",
    cartValidationPriceNow: "Ahora:",
    cartValidationAccept: "Aceptar",
    marcaBlancaAddressInfoTitle: "Información del comercio",
    marcaBlancaAccountStepLabel: "Cuenta ePayco",
    marcaBlancaBranchStepLabel: "Selecciona la sucursal",
    marcaBlancaBranchHintBefore:
      "En caso de no visualizar la sucursal deseada, ",
    marcaBlancaBranchHintLink: "ingresa a tu cuenta de ePayco",
    marcaBlancaBranchHintAfter:
      " para registrar una nueva o validar el estado de una existente.",
    marcaBlancaBranchPlaceholder: "Seleccionar",
    marcaBlancaBranchLinkedCount: "{count} vinculados (Máx {max})",
    marcaBlancaBranchDataStepLabel: "Datos de la sucursal",
    marcaBlancaBranchSummaryTitle: "Resumen de Datáfonos",
    marcaBlancaBranchLinked: "Vinculados: {count}",
    marcaBlancaBranchAvailable: "Disponibles: {count}",
    marcaBlancaBranchUnavailableTitle:
      "No hay datáfonos disponibles para esta sucursal",
    marcaBlancaBranchUnavailableMessage:
      "Los datáfonos disponibles para la sucursal son 0. Seleccione otra sucursal o ingrese a su cuenta ePayco para registrar o validad una nueva.",
    marcaBlancaBranchUnavailablePrimary: "Seleccione otra sucursal",
    marcaBlancaBranchUnavailableSecondary: "Cerrar",
    marcaBlancaBranchExceedsTitle:
      "Superaste la cantidad de datáfonos disponibles",
    marcaBlancaBranchExceedsMessage:
      "Seleccione otra sucursal o disminuya la cantidad de datafonos en el carrito.",
    marcaBlancaBranchExceedsPrimary: "Volver al carrito",
    marcaBlancaBranchExceedsSecondary: "Seleccionar otra sucursal",
    marcaBlancaAddressDetailLabel: "Detalles de la dirección",
    marcaBlancaSellerCodeStepLabel:
      "Agrega el código del agente vendedor (Opcional)",
    marcaBlancaSellerCodePlaceholder: "Escribe el código",
    marcaBlancaSellerCodeValidate: "Validar",
    marcaBlancaSellerCodeRejected:
      "El código ingresado no es válido, puedes corregirlo o continuar sin esta información.",
    marcaBlancaGenericErrorTitle:
      "Ocurrió un problema al momento de verificar la información.",
    marcaBlancaGenericErrorSupport: "Contactar a Soporte",
    marcaBlancaOnboardingErrorTitle: "Aún no puedes completar tu compra.",
    marcaBlancaOnboardingErrorMessage:
      "No es posible continuar con el proceso de compra. Si necesitas más información o ayuda para completar tu solicitud, comunícate con nuestro equipo de soporte.",
    marcaBlancaOnboardingRadicateMessage: "Iniciando tu proceso de registro...",
    marcaBlancaOnboardingMerchantMessage: "Generando tu CUVP...",
    marcaBlancaOnboardingAffiliateMessage:
      "Habilitando las franquicias disponibles...",
    marcaBlancaDocumentTypeMismatch:
      "El tipo de documento seleccionado no coincide con el registrado para este cliente.",
    marcaBlancaFeatureInactiveTitle: "Aún no puedes completar tu compra.",
    marcaBlancaFeatureInactiveMessage:
      "No es posible continuar con el proceso de compra. Si requieres más información o ayuda para completar tu solicitud, comunícate con nuestro equipo de soporte.",
    marcaBlancaAddressConfirmTitle: "Confirma tu dirección de envío",
    marcaBlancaAddressConfirmDescOne:
      "Antes de continuar, verifica que la dirección de entrega sea correcta.",
    marcaBlancaAddressConfirmDescTwo:
      "Si necesitas cambiarla, solicita la actualización de tu información por medio de Ticket de soporte. Una vez validados tus datos, podrás iniciar el proceso de compra.",
    marcaBlancaAddressConfirmAccept: "Sí, es correcta",
    marcaBlancaAddressConfirmRequestChange: "Solicitar cambio de dirección",
    marcaBlancaTamperTitle: "No es posible modificar los datos",
    marcaBlancaTamperError:
      "Los datos del comercio no pueden modificarse. Recarga la página para restaurarlos o solicita el cambio por Ticket de soporte.",
    minLenDocument: "Mínimo 6 caracteres",
    aditionalAddress:"Escribe la dirección más específica (opcional)",
    paymentCompleted: "Pago Completado",
    paymentTestModeCompleted: "Pago de prueba completado",
    paymentConfirmedMsg: "Tu pedido se confirmó correctamente.",
    paymentTestModeConfirmedMsg: "Esta compra se realizó en modo pruebas y no genera una orden de envío real.",
    orderNumber: "Número de pedido:",
    valuePaid: "Valor pagado",
    orderDetail: "Detalle del pedido",
    emailConfirmationMsg: "Te enviamos un correo con la confirmación a:",
    emailConfirmationMsg2: ", la factura te llegará en un correo separado. No olvides revisar tu carpeta de correo no deseado.",
    nextStep: "Próximo paso:",
    estimatedDelivery: "Fecha estimada de entrega",
    deliveryDate: "Fecha de entrega",
    deliveryTime: "Hora de entrega",
    preparingOrder: "Preparando tu pedido",
    preparingOrderDesc: "Te notificaremos cuando hayamos despachado tu pedido a tu dirección",
    scheduledShipment: "Envío programado",
    scheduledShipmentDesc: "Tu pedido está siendo preparado para envío",
    pendingOrder: "Pendiente",
    pendingOrderDesc: "Tu pedido está en proceso de confirmación",
    deliveredOrder: "Entregado",
    deliveredOrderDesc: "Tu pedido fue entregado exitosamente",
    followOrder: "Seguir mi pedido",
    copied: "¡Copiado!",
    sendOperator:"Envío con transportadora",
    quotationError:'No fue posible calcular el envío en este momento. Si el problema persiste, puedes contactarnos para ayudarte a finalizar tu compra.',
    shippingDetailTitle: "Detalles del envío",
    customerData: "Datos del cliente",
    deliveryMethod: "Método de entrega",
    downloadReceipt: "Descarga comprobante",
    keepShopping: "Seguir comprando",
    backToHome: "Volver al inicio",
    piece: "Pieza",
    pieces: "Piezas",
    trackMyOrder: "Seguir mi pedido",
    orderDetails: "Detalles del pedido",
    trackingStep1: "Pedido generado",
    trackingStep2: "Pedido recogido",
    trackingStep3: "En bodega de transportadora (Origen)",
    trackingStep4: "En camino a la ciudad destino",
    trackingStep5: "En bodega de transportadora (Destino)",
    trackingStep6: "En reparto",
    trackingStep7: "Pedido entregado",
    orderStatus: "Estado del pedido",
    estimatedDeliveryDate: "Fecha estimada de entrega",
    backToDetail: "Volver al detalle",
    trackingError: "No logramos obtener el estado de tu pedido en este momento. Puede ser un problema temporal. Intenta nuevamente más tarde.",
    trackingNotApplicable: "No aplica",
    statusConfirmado: "Confirmado",
    statusRecogido: "Recogido",
    statusEnOrigen: "En origen",
    statusEnCamino: "En camino",
    statusEnDestino: "En destino",
    statusEnReparto: "En reparto",
    statusEntregado: "Entregado",
    aveFirstNameLabel: "Nombres",
    aveLastNameLabel: "Apellidos",
    aveDepartmentLabel: "Departamento",
    aveProvinceLabel: "Municipio",
    aveNumberLabel: "Número",
    aveTypeOfRoadLabel: "Tipo de vía",
    aveNameOrNumberOfRoadLabel: "Nombre o número de vía",
    aveTypeOfResidenceLabel: "Tipo de vivienda",
    aveUbicationDetailsLabel: "Detalle de la ubicación",
    aveUbicationDetailsExampleLabel: "Ej: Casa 12, Apto 302...",
    avePhoneLabel: "Teléfono (celular)",
    aveTypeOfRoadError: "Tipo de vía es obligatorio",
    aveNameOrNumberOfRoadError: "Nombre de la vía es obligatorio",
    aveNumber1Error: "Número es obligatorio",
    aveNumber2Error: "Número 2 es obligatorio",
    aveTypeOfResidenceError: "Tipo de vivienda es obligatorio",
    aveUbicationDetailsError: "Detalle de la ubicación es obligatorio",
    aveonlineLoginError: "La tienda presenta una novedad en este momento. Por favor contacta al comercio para recibir ayuda.",
    aveRoadCarrera: "Carrera",
    aveRoadStreet: "Calle",
    aveRoadAvenue: "Avenida",
    aveRoadTransverse: "Transversal",
    aveRoadDiagonal: "Diagonal",
    aveRoadCircular: "Circular",
    aveRoadOther: "Otros",
    aveResidenceHouse: "Casa",
    aveResidenceApartment: "Apartamento",
    aveResidenceResidentialUnit: "Unidad residencial",
    aveResidenceBuilding: "Edificio",
    aveResidenceGatedCommunity: "Conjunto cerrado",
    aveResidenceOffice: "Oficina",
    aveResidenceOther: "Otro",
    close: "Cerrar",
    aveGeneratingGuide: "En proceso de generación...",
    aveGeneratingGuideTest: "No disponible en modo pruebas.",
    mbDeliveryPoint: "Entrega coordinada en el punto",
    mbDeliveryHome: "Entrega coordinada a domicilio",
    mbSellerCode: "Código vendedor",
    mbSellerCodeInvalid:
      "El código debe tener letras y números, con guiones solo en medio (máximo 50 caracteres).",
    mbSellerCodeRejected: "El código de vendedor no es válido.",
    mbSellerCodeError:
      "No pudimos verificar el código de vendedor. Intenta de nuevo.",
    mbSellerCodeMissing:
      "La entrega en el punto requiere un código de vendedor validado.",
  },
  ENG: {
    featured: "Featured",
    outstanding: "Highlighted",
    searchPlaceholder: "Search for products, categories, and more",
    searchMessage: "Enter a word to start the search",
    home: "Home",
    category: "Categories",
    allCategory: "All categories",
    selling: "Start selling",
    footerAdvertising:
      "Create an account now and share your products and catalogs",
    newAccount: "Create account",
    termsAndConditions: "Terms and conditions",
    contact: "Contact the store",
    loading: "Loading",
    notFoundProduct: "No products match the search",
    resultFor: "results for",
    showing: "Showing",
    products: "products",
    products2: "Products",
    sortBy: "Sort by",
    recent: "Recent",
    lowestFirst: "Lowest price first",
    highestFirst: "Highest price first",
    from: "From",
    optionSend: "Shipping options",
    messageDelivery:
      "You are viewing prices available for purchase at this location. If this is not where you are, you can change it here",
    maintainLocation: "Keep Location",
    changeLocation: "Change Location",
    messageDeliverySelected:
      "You must select the city where the order will be delivered and the provider who will deliver it",
    ok: "Agree",
    sendFree: "FREE shipping",
    allProduct: "For all products",
    continueCategory: "Continue viewing more products from this category",
    more: "See more",
    summary: "Summary of your purchase",
    subtotal: "Subtotal",
    tax: "Taxes",
    tax2: "taxes",
    tax3: "Tax",
    discount: "Discount",
    free: "Free",
    free2: "FREE",
    send: "Shipping",
    freeShipping: "Free shipping",
    freeShippingProductPrefix: "Add just",
    freeShippingProductSuffix: "more to get free shipping",
    freeShippingProductFooterStrong: "Automatic free shipping",
    freeShippingProductFooterMiddle: "applied when exceeding",
    freeShippingProductFooterSuffix: "in the cart.",
    freeShippingStepOnePrefix: "You're only",
    freeShippingStepOneMiddle: "away from",
    freeShippingStepOneStrong: "FREE SHIPPING",
    freeShippingStepsPrefix:
      "There's still time. Add more products and enjoy FREE shipping on purchases from",
    freeShippingReached: "All set! Your free shipping was applied successfully!",
    freeShippingBannerStrong: "Take advantage!",
    freeShippingBannerPrefix: "If your purchase exceeds",
    freeShippingBannerSuffix: "shipping is on us.",
    codeMessage:
      "Discount codes and shipping costs are added in the following steps.",
    errorCode: "These discount codes cannot be used at the same time.",
    errorCode2: "This discount code is not available",
    errorCode3: "This code has already been added",
    errorCode4: "An error occurred while consulting the coupon",
    errorCode5:
      "This discount code will be applicable on purchases greater than {amount}",
    errorCode6: "This discount code can only be applied to products from",
    errorCode7: "The total purchase amount can not be 0",
    errorCode8: "This coupon can only be applied to the follow categories {categories}",
    errorCode9:
      "These discount codes cannot be used at the same time. The maximum total discount is 90%.",
    error: "An error has occurred,",
    codeDiscount: "Discount code",
    total: "Total",
    messageSubtotalsend: "May vary according to shipping information",
    agree: "Agree",
    authorization:
      "I authorize in advance, expressly and unequivocally that my personal data be processed by Epayco.com in accordance with the purposes established in its",
    authorization3: `I authorize in advance, expressly and unequivocally that my personal data be treated by epayco.com`,
    authorization4:
      "to process my personal data in accordance with the purposes set forth in its ",
    authorization2: "Personal data processing policy",
    messageCityChange: `Please note that by changing the selected address, the shipping costs will be recalculated.`,
    location: "Location",
    locationChangeSuccess:
      "Your location has been successfully updated, you can make the change whenever necessary",
    page: "Page",
    of: "of",
    prev: "Previous",
    next: "Next",
    conditionPage:
      "The value can't be 0 or greater than the total number of pages",
    province: "Department",
    city: "City",
    country: "Country",
    seletedCity: "Select a city",
    selectedDepartament: "Select a department",
    selectedContry: "Select a country",
    selectedProvince: "Select a department",
    messageShipping:
      "This location will help us provide you with a better shopping experience. If it is not the location where you need the order, you can change it here.",
    labelInputsShiping: "State / department",
    save: "Save",
    cancel: "Cancel",
    addProductSuccess: "Product successfully added to your shopping cart",
    ref: "Reference",
    totalToPay: "Total to pay",
    viewCart: "View cart",
    cart: "Cart",
    continueShopping: "Continue shopping",
    continue: "Continue",
    placeholderSearch: "Search products, categories and more...",
    summaryPurchase: "Purchase summary",
    detailPay: "Payment detail",
    information: "Information",
    relatedProduct: "Related products",
    urlCopy: "URL copied",
    shippingProvider: "Carrier",
    cost: "Cost",
    messageInfoRequered:
      "We are sorry, please complete the requested information.",
    shoppingCart: "Shopping cart",
    shoppingCartEmpty: "Your cart is currently empty",
    sucessPay: "Successful purchase!",
    messageSucessPay:
      "We have sent a message to the registered email with the result of the purchase",
    pendingPay: "Pending payment",
    messagePendingPay:
      "We will send you a message to the registered email as soon as your payment is confirmed",
    rejectPay: "Payment rejected",
    messageRejectPay:
      "An error occurred while making the payment, please try again",
    unit: "unit",
    units: "units",
    space: "Space",
    product: "Product",
    amount: "Amount",
    price: "Price",
    methodShipping: "Shipping method",
    receives: "Receives",
    phone: "Phone",
    email: "Email",
    payment: "Your payment",
    pay: "Pay",
    paymentNumber: "Payment number",
    transactionDate: "Transaction date",
    hour: "Hour",
    productSummary: "Product summary",
    contactEcommerce: "Contact the Merchant",
    cellPhone: "Incorrect cell phone number",
    printMessage: "Write a message here",
    tryLater: "We are sorry, an unexpected error has occurred. Try later",
    hi: "Hi, tell us how we can help you?",
    catalogueInactive: "This catalog is inactive",
    shoppingDelete: "Cart has been abandoned or deleted.",
    messageElogisticaError:
      "You have just exceeded the weight and/or dimensions limit of the cart, we recommend you split your order into 2 purchases",
    messageElogisticaError2:
      "We are sorry, at this moment there is no logistics service available for the destination you selected. Please contact the selling merchant",
    messageElogisticaError3:
      "The weight and / or dimensions of one of the products are misconfigured, we recommend that you contact the seller.",
    messageElogisticaError4:
      "We are sorry, an unexpected error has occurred. Please contact the selling merchant.",
    categories: "the categories",
    category2: "the category",
    consulting: "consulting",
    phoneInvalid: "Enter a valid phone number",
    saveInfo: "Save information",
    messageAuthorization:
      "By selecting this box, you authorize ePayco to securely store your shipping information for future purchases.",
    back: "Back",
    menssageChangeInfo: `By changing the department and / or city, the shipping value of the products is recalculated.`,
    inputAddress: "Enter an address",
    infoContact: "Contact information",
    inputEmail: "Enter your email to start",
    completedInfo: "Complete information",
    name: "Name",
    lastname: "Lastname",
    inputName: "Enter your name",
    inputLastname: "Enter your lastname",
    inputNumber: "Enter your document number",
    numberDoc: "Document number",
    address: "Address",
    otherAdress: "Other details (optional)",
    empatyCart: "Your shopping cart is empty",
    addProduct: "Add products",
    politycData: "Personal data processing policy",
    sentMessage: "Shipping made with eLogística",
    dataCommerce: "Buyer's data",
    deliveryCommerce: "Delivery coordinated with the commerce",
    sorry: "We are sorry!",
    notFound: "Page not found",
    searchMessage2: "what are you looking for",
    goHome: "Go to home",
    inactiveCatalogue: "Catalog not available",
    messageInactiveCatalogue1: "Currently this catalog is not",
    messageInactiveCatalogue2:
      "available, try again later or contact the commerce",
    createAccount:
      "Create an account and start selling and collecting securely with ePayco",
    learnMore: "Learn more about ePayco",
    chooseReference: "Choose a reference",
    productsAvailable: "available products",
    calculateShipping: "Calculate shipping",
    selectDeliveryCity: "Select delivery city",
    buyNow: "Buy now",
    addToCart: "Add to cart",
    accept: "Accept",
    chooseOtherPaymentMethod: "Choose another payment method",
    print: "Print",
    paymentOf: "Payment of",
    FourSevenTwoShipping: "4-72 Shipping",
    goToHomePage: "Go to the home page",
    categories2: "Categories",
    backShoping: "Buy Again",
    sendTo: "Sent to",
    infoCart: "Info",
    paymentCart: "Payment",
    addMoreProducts: "Add more products",
    valueNextStep: `*Value calculated\nin the next step`,
    payCart: "Pay",
    noCartError: "We did not find a cart",
    epaycoCom: "Epayco.com",
    termsAgreement: "I agree to ePayco ",
    termsAgreement2: " of service.",
    transactionAmountValidation:
      "The value of the transaction is outside the amounts allowed by the business",
    productUnavailable: "Product unavailable",
    transactionError: "There was an error trying to make the transaction",
    restrictedUser: "The transaction cannot be processed at this time in accordance with our policies. For more information, please contact the support team.",
    inputSelect: "Select...",
    nameAveonline:"Writes...",
    messageAuthorizationAveonline:"By selecting this box, you are authorizing us to securely store your shipping information for future purchases.",
    documentNit: "Invalid format. Ej: 900123456-7",
    documentNumber:"Just numbers",
    cc: 'National identity card',
    nit: 'NIT',
    typeDocumentLabel: "Type Document",
    documentNumberLabel: "Document number",
    documentTypeRequired: "Document type is required",
    documentNumberRequired:"Document number is required",
    marcaBlancaTitle: "Enter the requested information.",
    marcaBlancaIntroOne: "We will use this information to validate your model account",
    marcaBlancaIntroTwo: "ePayco Aggregator. If you meet the requirements, you can proceed with",
    marcaBlancaIntroThree: "la compra.",
    marcaBlancaIdLabel: "ePayco ID",
    marcaBlancaNumberPlaceholder: "Document number",
    marcaBlancaEnter: "Validate",
    marcaBlancaClose: "Close",
    marcaBlancaIdRequired: "ePayco ID is required and only accepts numbers",
    marcaBlancaIdInvalid: "Invalid ePayco ID",
    marcaBlancaNoAccount: "Don't have an ePayco account? You can ",
    marcaBlancaCreateLink: "create it now",
    marcaBlancaNoAccountSuffix: " and come back to complete your order.",
    marcaBlancaReqTitle: "You can't complete your purchase yet",
    marcaBlancaReqIntro:
      "To buy your card reader, you must first complete the following requirements:",
    marcaBlancaReqAggregator: "Aggregator model type",
    marcaBlancaReqValidated: "Account validated 100%",
    marcaBlancaReqDavivienda: "Davivienda Plan account",
    marcaBlancaReqDaviviendaDesc:
      "You need a linked and default Davivienda account to continue with the purchase.",
    marcaBlancaReqDaviviendaDescAction:
      "You need a linked and default Davivienda account to continue with the purchase.",
    marcaBlancaReqAcknowledge: "Understood",
    marcaBlancaReqIntroNotFound:
      "You need to create an ePayco account before buying your card reader.",
    marcaBlancaReqIntroAlreadyBought:
      "You can't purchase more card readers for your branches.\nLog in to your ePayco account to register a new branch\nor validate the status of an existing one.",
    marcaBlancaReqAggregatorDesc: "Your ePayco account must be Aggregator model",
    marcaBlancaReqValidatedDesc:
      "Complete the validation process to activate your account 100%.",
    marcaBlancaReqCtaCreate: "Create account",
    marcaBlancaReqCtaValidate: "Validate account",
    marcaBlancaReqCtaLink: "Link account",
    marcaBlancaCartLimitTitle: "You can't add more products to the cart.",
    marcaBlancaCartLimitMessage:
      "You've reached the maximum number of dataphones available for this purchase.",
    marcaBlancaCartLimitGoToCart: "Go to cart",
    cartValidationTitle: "Your cart needs changes",
    cartValidationIntro:
      "We can't continue with the payment because these items changed. Accept to go back to the cart and update them.",
    cartValidationGenericMessage:
      "We can't continue with the payment because your cart changed. Accept to go back to the cart and review it.",
    cartValidationStoreTitle: "The store is not available",
    cartValidationStoreMessage:
      "We are temporarily unavailable at the moment. Please try again later.",
    cartValidationInactiveProducts: "Products that are no longer available",
    cartValidationInactiveCategories: "Categories that are no longer available",
    cartValidationMissingReferences: "Variants that are no longer available",
    cartValidationChangedPrices: "Products whose price changed",
    cartValidationPriceBefore: "Before:",
    cartValidationPriceNow: "Now:",
    cartValidationAccept: "Accept",
    marcaBlancaAddressInfoTitle: "Business information",
    marcaBlancaAccountStepLabel: "ePayco account",
    marcaBlancaBranchStepLabel: "Select the branch",
    marcaBlancaBranchHintBefore:
      "If you don't see the branch you're looking for, ",
    marcaBlancaBranchHintLink: "sign in to your ePayco account",
    marcaBlancaBranchHintAfter:
      " to register a new one or check the status of an existing one.",
    marcaBlancaBranchPlaceholder: "Select",
    marcaBlancaBranchLinkedCount: "{count} linked (Max {max})",
    marcaBlancaBranchDataStepLabel: "Branch details",
    marcaBlancaBranchSummaryTitle: "Card Reader Summary",
    marcaBlancaBranchLinked: "Linked: {count}",
    marcaBlancaBranchAvailable: "Available: {count}",
    marcaBlancaBranchUnavailableTitle:
      "No card readers available for this branch",
    marcaBlancaBranchUnavailableMessage:
      "There are 0 card readers available for this branch. Select another branch or sign in to your ePayco account to register or validate a new one.",
    marcaBlancaBranchUnavailablePrimary: "Select another branch",
    marcaBlancaBranchUnavailableSecondary: "Close",
    marcaBlancaBranchExceedsTitle:
      "You exceeded the available card readers",
    marcaBlancaBranchExceedsMessage:
      "Select another branch or lower the number of card readers in the cart.",
    marcaBlancaBranchExceedsPrimary: "Back to cart",
    marcaBlancaBranchExceedsSecondary: "Select another branch",
    marcaBlancaAddressDetailLabel: "Address details",
    marcaBlancaSellerCodeStepLabel: "Add the sales agent code (Optional)",
    marcaBlancaSellerCodePlaceholder: "Enter the code",
    marcaBlancaSellerCodeValidate: "Validate",
    marcaBlancaSellerCodeRejected:
      "The code you entered isn't valid, you can fix it or continue without this information.",
    marcaBlancaGenericErrorTitle:
      "There was a problem while verifying the information.",
    marcaBlancaGenericErrorSupport: "Contact Support",
    marcaBlancaOnboardingErrorTitle: "You can't complete your purchase yet.",
    marcaBlancaOnboardingErrorMessage:
      "It's not possible to continue with the purchase process. If you need more information or help completing your request, contact our support team.",
    marcaBlancaOnboardingRadicateMessage: "Starting your registration process...",
    marcaBlancaOnboardingMerchantMessage: "Generating your CUVP...",
    marcaBlancaOnboardingAffiliateMessage: "Enabling the available card brands...",
    marcaBlancaDocumentTypeMismatch:
      "The selected document type does not match the one registered for this client.",
    marcaBlancaFeatureInactiveTitle: "You can't complete your purchase yet.",
    marcaBlancaFeatureInactiveMessage:
      "It's not possible to continue with the purchase process. If you need more information or help completing your request, contact our support team.",
    marcaBlancaAddressConfirmTitle: "Confirm your shipping address",
    marcaBlancaAddressConfirmDescOne:
      "Before continuing, make sure the delivery address is correct.",
    marcaBlancaAddressConfirmDescTwo:
      "If you need to change it, request an update of your information through a support ticket. Once your data is validated, you'll be able to start the purchase process.",
    marcaBlancaAddressConfirmAccept: "Yes, it's correct",
    marcaBlancaAddressConfirmRequestChange: "Request address change",
    marcaBlancaTamperTitle: "The data cannot be modified",
    marcaBlancaTamperError:
      "The merchant's data cannot be modified. Reload the page to restore it or request the change through a support ticket.",
    minLenDocument: "Minimum 6 characters",
    aditionalAddress:"Write the more specific address (optional)",
    paymentCompleted: "Payment Completed",
    paymentTestModeCompleted: "Trial payment completed",
    paymentConfirmedMsg: "Your order was confirmed correctly.",
    paymentTestModeConfirmedMsg: "This purchase was made for testing purposes and does not result in an actual shipping order.",
    orderNumber: "Order number:",
    valuePaid: "Value paid",
    orderDetail: "Order detail",
    emailConfirmationMsg: "We sent a confirmation email to:",
    emailConfirmationMsg2: ", the invoice will arrive in a separate email. Don't forget to check your spam folder.",
    nextStep: "Next step:",
    estimatedDelivery: "Estimated delivery date",
    deliveryDate: "Delivery date",
    deliveryTime: "Delivery time",
    preparingOrder: "Preparing your order",
    preparingOrderDesc: "We will notify you when we have dispatched your order to your address",
    scheduledShipment: "Scheduled shipment",
    scheduledShipmentDesc: "Your order is being prepared for shipment",
    pendingOrder: "Pending",
    pendingOrderDesc: "Your order is being confirmed",
    deliveredOrder: "Delivered",
    deliveredOrderDesc: "Your order was successfully delivered",
    followOrder: "Follow my order",
    copied: "Copied!",
    sendOperator:"Shipped via courier",
    quotationError:'Shipping costs could not be calculated at this time. If you continue to experience this issue, please contact us for assistance in completing your purchase.',
    shippingDetailTitle: "Shipping details",
    customerData: "Customer data",
    deliveryMethod: "Delivery method",
    downloadReceipt: "Download receipt",
    keepShopping: "Keep shopping",
    backToHome: "Back to home",
    piece: "Piece",
    pieces: "Pieces",
    trackMyOrder: "Track my order",
    orderDetails: "Order details",
    trackingStep1: "Order placed",
    trackingStep2: "Order picked up",
    trackingStep3: "At the carrier's warehouse (Origin)",
    trackingStep4: "On the way to destination city",
    trackingStep5: "At the carrier's warehouse (Destination)",
    trackingStep6: "Out for delivery",
    trackingStep7: "Order delivered",
    orderStatus: "Order status",
    estimatedDeliveryDate: "Estimated delivery date",
    backToDetail: "Back to detail",
    trackingError: "We were unable to get your order status at this time. This may be a temporary issue. Please try again later.",
    trackingNotApplicable: "Not applicable",
    statusConfirmado: "Confirmed",
    statusRecogido: "Picked up",
    statusEnOrigen: "At origin",
    statusEnCamino: "In transit",
    statusEnDestino: "At destination",
    statusEnReparto: "Out for delivery",
    statusEntregado: "Delivered",
    aveFirstNameLabel: "First name",
    aveLastNameLabel: "Last name",
    aveDepartmentLabel: "Department",
    aveProvinceLabel: "Province",
    aveNumberLabel: "Number",
    aveTypeOfRoadLabel: "Type of road",
    aveNameOrNumberOfRoadLabel: "Name or number of road",
    aveTypeOfResidenceLabel: "Type of residence",
    aveUbicationDetailsLabel: "Location details",
    aveUbicationDetailsExampleLabel: "Example: home 12, Apartment 302...",
    avePhoneLabel: "Phone (cellular)",
    aveTypeOfRoadError: "Type of road is required",
    aveNameOrNumberOfRoadError: "Name or number of road is required",
    aveNumber1Error: "Number is required",
    aveNumber2Error: "Number 2 is required",
    aveTypeOfResidenceError: "Type of residence is required",
    aveUbicationDetailsError: "Location details is required",
    aveonlineLoginError: "The store is currently experiencing an issue. Please contact the store for assistance.",
    aveRoadCarrera: "Road",
    aveRoadStreet: "Street",
    aveRoadAvenue: "Avenue",
    aveRoadTransverse: "Transverse",
    aveRoadDiagonal: "Diagonally",
    aveRoadCircular: "Circle",
    aveRoadOther: "Other",
    aveResidenceHouse: "House",
    aveResidenceApartment: "Apartment",
    aveResidenceResidentialUnit: "Residential unit",
    aveResidenceBuilding: "Building",
    aveResidenceGatedCommunity: "Gated community",
    aveResidenceOffice: "Office",
    aveResidenceOther: "Other",
    close: "Close",
    aveGeneratingGuide: "Being generated...",
    aveGeneratingGuideTest: "Not available in test mode",
    mbDeliveryPoint: "Coordinated pickup at point",
    mbDeliveryHome: "Coordinated home delivery",
    mbSellerCode: "Seller code",
    mbSellerCodeInvalid:
      "The code must contain letters and numbers, with hyphens only in the middle (50 characters max).",
    mbSellerCodeRejected: "The seller code is not valid.",
    mbSellerCodeError:
      "We couldn't verify the seller code. Please try again.",
    mbSellerCodeMissing:
      "Pickup at the point requires a validated seller code.",
  },
};
